import {UIGameExpandContractAnimation} from './../../ui_canvas_engine/animation/UIGameExpandContractAnimation'
import {PIXI} from '@colonist/pixi'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {UIGameMapDiceHighlightView} from './UIGameMapDiceHighlightView'
import {HexFace, Point} from '@colonist/game-mechanic-validators'
import {SectionView} from '../../ui_canvas_engine/SectionView'
import {UIGameGoToPointAnimation} from '../../ui_canvas_engine/animation/UIGameGoToPointAnimation'

export class UIGameMapDiceProbabilityView extends SectionView {
    private readonly size: number
    private readonly center: Point
    private readonly highlightDiceView: UIGameMapDiceHighlightView

    private readonly animation: UIGameExpandContractAnimation

    readonly hexFace: HexFace
    swapDiceProbabilityAnimation?: UIGameGoToPointAnimation

    constructor(x: number, y: number, w: number, h: number, hexFace: HexFace, container: PIXI.Container, texture: PIXI.Texture) {
        super(x, y, w, h, container, false)

        this.size = w
        this.center = new Point(x + this.size / 2, y + this.size / 2)
        new SpriteView(0, 0, this.width, this.height, this, texture)

        const highlightDiceX = -this.width * 0.01
        const highlightDiceY = -this.height * 0.01
        const highlightDiceW = w * 0.96
        this.highlightDiceView = new UIGameMapDiceHighlightView(highlightDiceX, highlightDiceY, highlightDiceW, this)
        this.highlightDiceView.hide()
        this.hexFace = hexFace

        this.animation = new UIGameExpandContractAnimation(this)
    }

    animate() {
        if(this.animation.isAnimationInProgress) return
        this.animation.start()
    }

    resetAnimation() {
        this.animation.stop()
    }

    highlight() {
        this.highlightDiceView.show()
    }

    removeHighlight() {
        this.highlightDiceView.hide()
    }
}
